import type { WithActiveBranchId } from '@app/api/shared';

export enum EmployeeSalaryEndpoints {
  SearchEmployees = 'SearchEmployees',
  GetListBy = 'GetListBy',
  Update = 'Update',
  Confirm = 'Confirm',
  RevokeConfirm = 'RevokeConfirm',
  ExportToExcel = 'ExportToExcel',
}

export enum EmployeeSalaryUrls {
  SearchEmployees = 'SearchEmployees',
  GetListBy = 'GetListBy',
  Update = 'Update',
  Confirm = 'Confirm',
  RevokeConfirm = 'RevokeConfirm',
  ExportToExcel = '',
}

export interface ModelEmployeeSalarySearchFilter {
  Year: number;
  Month: number;
}

export interface ModelEmployeeSalary {
  PositionId: number | null;
  UserId: number;
  AdvanceAmount: number;
  BonusAmount: number;
  TotalAmount: number;
  OfficialAmount: number;
  TimeConfirmed: string | null;
  Comment: string | null;
  UserFullName: string | null;
  PositionName: string | null;
  BranchId: number;
  IsDeleted: boolean;
}

export interface ModelEmployeeSalarySearchResult {
  Filter: ModelEmployeeSalarySearchFilter;
  Salaries: ModelEmployeeSalary[] | null;
}

export interface ModelEmployeeSalaryLiteItem {
  Month: string | null;
  Year: string | null;
  Label: string | null;
  Amount: number;
  IsConfirmed: boolean;
}

export interface ModelEmployeeSalaryListMe {
  UserId: number;
  Salaries: ModelEmployeeSalaryLiteItem[] | null;
}

export interface ModelEmployeeSalaryUpdate {
  UserId: number;
  AdvanceAmount: number;
  BonusAmount: number;
  TotalAmount: number;
  OfficialAmount: number;
  Timestamp: string;
  Comment: string | null;
}

export interface ModelEmployeeSalaryConfirm {
  UserIds: number[] | null;
  Year: number;
  Month: number;
  Comment: string | null;
}

export interface ModelEmployeeSalaryRevokeConfirm {
  UserIds: number[] | null;
  Year: number;
  Month: number;
}

export interface ModelEmployeeSalaryConfirmResult {
  UpdatedIds: number[] | null;
  FailedIds: number[] | null;
}

export interface EmployeeSalaryModelFile {
  Id: number;
  Name: string | null;
  Data: string | null;
  Lifetime: string | null;
  Description: string | null;
}

export type SearchEmployeeSalaryEmployeesRequest = WithActiveBranchId<{
  data: ModelEmployeeSalarySearchFilter;
}>;

export type GetListByRequest = WithActiveBranchId<{
  userId: number | null;
  maxCount: number;
}>;

export type UpdateEmployeeSalaryRequest = WithActiveBranchId<{
  data: ModelEmployeeSalaryUpdate;
}>;

export type ConfirmRequest = WithActiveBranchId<{
  data: ModelEmployeeSalaryConfirm;
}>;

export type RevokeConfirmRequest = WithActiveBranchId<{
  data: ModelEmployeeSalaryRevokeConfirm;
}>;

export type ExportEmployeeSalaryToExcelRequest = WithActiveBranchId<{
  filterMonth: number;
  filterYear: number;
}>;

export type SearchEmployeeSalaryEmployeesResponse =
  ModelEmployeeSalarySearchResult;
export type GetListByResponse = ModelEmployeeSalaryListMe;
export type UpdateEmployeeSalaryResponse = ModelEmployeeSalary;
export type ConfirmResponse = ModelEmployeeSalaryConfirmResult;
export type RevokeConfirmResponse = ModelEmployeeSalaryConfirmResult;
export type ExportEmployeeSalaryToExcelResponse = EmployeeSalaryModelFile;
